import ArrowDownIcon from '@/assets/icons/arrow-down-icon.svg';
import ArrowUpIcon from '@/assets/icons/arrow-up-icon.svg';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const transactionListStyles = {
    '&.transaction-list': {
        '& .statistics-boxes': {
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                marginBottom: '20px !important',
            },
        },
        '& .RaDatagrid-row.RaDatagrid-expandable': {
            [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                padding: '20px 24px',
            },
        },
        '& .MuiTableRow-root': {
            '&:hover, &:active, &.checked': {
                '& .MuiTableCell-root.RaDatagrid-expandIconCell + .MuiTableCell-root': {
                    boxShadow: `1px 0 0 0 ${Palette.gray.gray50}, -2px 0 0 0 ${Palette.gray.gray300}, 0 -2px 0 0 ${Palette.gray.gray300}, 0 2px 0 0 ${Palette.gray.gray300} !important`,
                },
            },
            '&:hover': {
                [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                    backgroundColor: `${Palette.white} !important`,
                },
                '& .MuiTableCell-root': {
                    [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                        boxShadow: 'none !important',
                        backgroundColor: Palette.white,
                    },
                    '&.column-transactionTime': {
                        [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                            backgroundColor: 'transparent !important',
                            '&:hover': {
                                backgroundColor: 'transparent !important',
                            },
                        },
                    },
                },
            },
        },
        '& .MuiTableCell-root': {
            [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                width: 'auto !important',
                '&.column-collectionPoint\\.id, &.column-transactionTime': {
                    width: '100% !important',
                },
                '&.column-collectionPoint\\.id': {
                    borderBottom: `2px solid ${Palette.gray.gray75}`,
                },
                '&.column-transactionTime': {
                    backgroundColor: 'transparent !important',
                    '&:hover': {
                        backgroundColor: 'transparent !important',
                    },
                },
            },
            '& .MuiTypography-root': {
                display: 'block',
                '& .product-measurements': {
                    '& .MuiTypography-root': {
                        display: 'inline-block',
                    },
                },
            },
            '& .product-measurements': {
                '& .MuiTypography-root': {
                    display: 'block',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        display: 'inline',
                    },
                },
            },
            '&.column-validContainersSum, &.column-invalidContainersSum': {
                '& svg': {
                    display: 'none',
                    [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                        display: 'block',
                        minWidth: '20px',
                        height: 'auto',
                    },
                },
            },
        },
        '& .column-contractor': {
            [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                display: 'none',
            },
        },
        '& tr.RaDatagrid-clickableRow': {
            '&:hover > td.MuiTableCell-body': {
                backgroundColor: `${Palette.gray.gray50} !important`,
                [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                    backgroundColor: `${Palette.white} !important`,
                },
            },
        },
        '& .product-card-container': {
            backgroundColor: Palette.white,
        },
        '& tr.active.RaDatagrid-expandable': {
            borderRadius: '20px 20px 0 0',
            '& .MuiTableCell-root.MuiTableCell-paddingCheckbox': {
                borderRadius: '20px 0 0 0',
            },
            '& td.MuiTableCell-root': {
                backgroundColor: Palette.white,
            },
        },
        '& tr.RaDatagrid-expandedPanel': {
            backgroundColor: Palette.white,
            '& td.MuiTableCell-root': {
                backgroundColor: Palette.white,
                '& .transaction-details-content': {
                    backgroundColor: Palette.white,
                    '& .transaction-details-content-top-bar': {
                        '& > .MuiBox-root': {
                            display: 'flex',
                            flexDirection: 'column',
                        },
                    },
                },
                '& .transaction-details-content-top-bar': {
                    '& > .MuiBox-root': {
                        display: 'flex',
                        flexDirection: 'column',
                    },
                },
            },

            [`@media (max-width: ${breakpoints.values.lg}px)`]: {
                '& td.MuiTableCell-root': {
                    backgroundColor: 'transparent',
                    '& .transaction-details-content': {
                        marginTop: '-2px',
                        backgroundColor: Palette.white,
                        borderRadius: '0 0 20px 20px',
                        paddingTop: '0px',
                        boxShadow: '0 14px 40px -2px rgba(0, 0, 0, 0.10), 0 10px 10px -8px rgba(0, 0, 0, 0.06)',
                        '& .product-card-container': {
                            paddingRight: '0px',
                            borderBottom: 'none',
                            '& + .product-card-container': {
                                marginTop: '-13px',
                            },
                            '&:last-child': {
                                paddingBottom: '12px',
                            },
                            '& .MuiPaper-root.MuiPaper-elevation': {
                                padding: '16px 24px !important',
                            },
                            '& .product-card-image': {
                                display: 'none',
                            },
                            '& .tag-list': {
                                display: 'none',
                            },
                            '& .MuiCardContent-root': {
                                padding: '0px !important',
                                '& .product-card-name': {
                                    display: 'block',
                                    '& .product-name': {
                                        fontSize: '11px',
                                        textTransform: 'uppercase',
                                        display: 'block',
                                    },
                                    '& .product-small-text': {
                                        display: 'inline-block',
                                        verticalAlign: 'middle',
                                        minWidth: '50%',
                                        padding: '6px 0px 0px 0px',
                                        '& + .product-small-text': {
                                            textAlign: 'right',
                                            maxWidth: '30%',
                                            textDecoration: 'none',
                                            fontSize: '11px',
                                            lineHeight: '16px',
                                            position: 'relative',
                                            zIndex: 2,
                                        },
                                    },
                                },
                            },
                            '& .product-card-options': {
                                display: 'none',
                            },
                            '&:last-of-type': {
                                borderBottom: 'none',
                            },
                        },
                        '& .transaction-details-content-top-bar': {
                            margin: '0px 24px 11px 24px',
                            padding: '16px',
                            gap: '10px',
                            position: 'relative',
                            '&::before': {
                                position: 'absolute',
                                bottom: '-16px',
                                left: 0,
                                content: '""',
                                display: 'block',
                                width: '100%',
                                height: '2px',
                                backgroundColor: Palette.gray.gray75,
                            },
                            '& .MuiTypography-root.MuiTypography-caption': {
                                marginBottom: '0px',
                                display: 'block',
                            },
                            '& .MuiTypography-h6': {
                                fontSize: '11px',
                            },
                            '& svg': {
                                width: '16px',
                                height: '16px',
                            },
                        },
                    },
                },
            },
        },
        [`@media (max-width: ${breakpoints.values.lg}px)`]: {
            '& .RaDatagrid-table td:last-child, & .RaDatagrid-table th:last-child': {
                position: 'static !important',
                right: 'auto',
                width: 'auto !important',
            },
            '& .RaDatagrid-root.responsive-table .RaDatagrid-tbody .RaDatagrid-row.RaDatagrid-expandable': {
                display: 'grid !important',
                position: 'relative',
                gridTemplateColumns: 'auto auto 1fr auto auto',
                gridTemplateRows: 'auto auto auto',
                alignItems: 'center',
                columnGap: '16px',
                rowGap: '12px',
                backgroundColor: Palette.white,
                backgroundImage: `url("${ArrowDownIcon}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'calc(100% - 24px) calc(100% - 20px)',
                backgroundSize: '20px 20px',
                '&:has(+ .RaDatagrid-expandedPanel)': {
                    backgroundImage: `url("${ArrowUpIcon}")`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'calc(100% - 24px) calc(100% - 20px)',
                    zIndex: 1,
                    boxShadow: 'none',
                    borderRadius: '20px 20px 0 0',
                },
                '& > .MuiTableCell-root': {
                    display: 'none',
                    width: 'auto !important',
                    minWidth: 0,
                    maxWidth: 'none',
                    margin: 0,
                },
                '& > .options-field': {
                    display: 'block !important',
                    position: 'absolute !important',
                    top: '24px',
                    right: '24px',
                    zIndex: 2,
                    width: 'auto !important',
                    padding: 0,
                    backgroundColor: 'transparent !important',
                },
                '&:has(> .options-field) > .column-collectionPoint\\.id': {
                    paddingRight: '40px',
                },
                '& > .column-collectionPoint\\.id': {
                    display: 'block !important',
                    order: 0,
                    gridColumn: '1 / -1',
                    gridRow: '1',
                    width: '100% !important',
                    '& .MuiTypography-root': {
                        paddingBottom: '6px',
                        marginBottom: '-4px',
                        '& span': {
                            lineHeight: '22px',
                        },
                    },
                },
                '& > .column-validContainersSum': {
                    display: 'block !important',
                    order: 1,
                    gridColumn: '1',
                    gridRow: '2',
                    justifySelf: 'start',
                },
                '& > .column-invalidContainersSum': {
                    display: 'block !important',
                    order: 2,
                    gridColumn: '2',
                    gridRow: '2',
                    justifySelf: 'start',
                },
                '& > .column-payout\\.type': {
                    display: 'block !important',
                    order: 3,
                    marginLeft: 'auto',
                    gridColumn: '4',
                    gridRow: '2',
                    justifySelf: 'end',
                    '& .payout-type-icon': {
                        marginRight: '0px !important',
                    },
                    '& .device-state-field-name': {
                        display: 'none',
                    },
                    '& svg': {
                        position: 'relative',
                        top: '3px',
                    },
                },
                '& > .column-payout\\.detailsCash': {
                    display: 'block !important',
                    order: 4,
                    gridColumn: '5',
                    gridRow: '2',
                    justifySelf: 'end',
                    textAlign: 'right',
                    '& .MuiTypography-root': {
                        fontWeight: '500',
                    },
                },
                '& > .column-transactionTime': {
                    display: 'block !important',
                    order: 10,
                    gridColumn: '1 / -1',
                    gridRow: '3',
                    width: '100% !important',
                    backgroundColor: 'transparent',
                    '& .MuiTypography-root': {
                        paddingTop: '6px',
                        marginTop: '-4px',
                        borderTop: `2px solid ${Palette.gray.gray75}`,
                        fontSize: '11px',
                    },
                },
                '& > .transaction-metrics-cell .MuiTypography-root': {
                    display: 'inline',
                    width: 'auto',
                    fontWeight: '600',
                },
            },
        },
    },
};
